import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProtoService } from './proto.service';
import { MainService } from 'src/app/modules/main/services/main.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessesService {

  private businessActive = new BehaviorSubject<any>(null);

  private businesses = new BehaviorSubject<Array<any>>([]);

  private numBusinesses: number;

  constructor(private protoSrv: ProtoService,
              private mainSrv: MainService,
              private dataSrv: DataService
  ) { 
    this.numBusinesses = 0;
  }

  public getBusiness(): any {
    return this.businessActive.value;
  }

  public setBusinessActive(business: any): void {
    if (business) {
      this.mainSrv.setBusiness(business.id, business.name, business.logoUrl, true);
    } else {
      this.dataSrv.setBusinessActive(false);
    }
    this.businessActive.next(business);
  }

  public getBusinessActive(): Observable<any> {
    return this.businessActive;
  }

  public setBusinesses(businesses: Array<any>): void {
    this.businesses.next(businesses);
  }

  public getBusinesses(): Observable<Array<any>> {
    return this.businesses;
  }

  public getAllBusinesses(): void {
    this.numBusinesses = 0;
    this.mainSrv.getBusinesses().subscribe(data => {
      const answer = this.protoSrv.decodeFindBusinessByUserActionProtoResponse(data);
      if (this.protoSrv.isFindBusinessesSuccess(answer)) {
        const aux = this.mainSrv.getAllBusinesses(answer);
        let businesses: Array<any> = [];
        let index = 0; 
        aux.forEach((element: any) => {
          if (!element.logoUrl) {
            element.logoUrl = '';
          }
          element.index = index;
          businesses.push(element);
          this.numBusinesses += 1;
          index += 1;
          //this.businessesService.getBusinesses().push(element);
        });
        this.setBusinesses(businesses);
        // if(businesses.length == 1) {
        //   this.setBusinessActive(this.businesses[0]);
        // }
      }      
    }, error => {
      console.log(error);
    });
  }

  public reset(): void {
    this.businessActive.next(null);
    this.businesses.next([]);
    this.numBusinesses = 0;
  }

}
